export const OK_TO_BOARD = 'OK TO BOARD';

export const IROPS_TYPE = 'YY';

export const IROPS_REMARK = 'OPERATIONALIROPDELAYEDDIGITAL';

export const CODES_OVERWEIGHT = ['OW2', '0FG', '0EZ', '0C6', '0C9'];

export const MAX_LINEAL_BAG_DIMENSION = 158;

export const DOCUMENTATION_WINDOW = {
  OPENING_HOURS: 4,
  DOMESTIC_CLOSING_MINUTES: 60,
  INTERNATIONAL_CLOSING_MINUTES: 60,
} as const;
